// src/utils/date.js
import dayjs from "dayjs";
import jalaliday from "jalaliday";

// فقط یک‌بار افزونه فعال می‌شود
dayjs.extend(jalaliday);

/**
 * فرمت کردن تاریخ به شمسی (جلالی)
 * @param {string|Date} date - تاریخ میلادی (string یا Date)
 * @param {string} format - فرمت دلخواه، پیش‌فرض: YYYY/MM/DD HH:mm
 * @returns {string} تاریخ شمسی فرمت‌شده یا "-" در صورت نامعتبر بودن
 */
export function formatJalali(date, format = "YYYY/MM/DD - HH:mm") {
  if (!date) return "-";
  try {
    return dayjs(date).calendar("jalali").locale("fa").format(format);
  } catch {
    return "-";
  }
}
